<div mat-dialog-title>
    <h1>{{aboutUs | translate}}</h1>
    <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div mat-dialog-content class="mat-dialog-content-padded">
    <pershing-responsive [respondToWindow]="true" [small]="smallRef" [medium]="smallRef"
        [large]="largeRef"></pershing-responsive>
    <ng-container *ngIf="resourceEntitled && hasResources && !isFromSiteBuilder && (hasAboutUs || hasContactUs || entitledForAdvisorInfo)">
        <br>
        <mat-expansion-panel class="fw-Advisor_SyncExpansion">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{titleId | translate}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <content-management (hasContent)="hasResourcesContent($event)" [isHeaderRequired]="false" class="fw-Advisor_SyncDetails" communityName="{{community}}"
            [articleId]="articleId"></content-management>
        </mat-expansion-panel>
    </ng-container>
    <ng-container *ngIf="resourceEntitled && hasResources && !isFromSiteBuilder && !hasAboutUs && !hasContactUs && !entitledForAdvisorInfo">
        <content-management (hasContent)="hasResourcesContent($event)" [isHeaderRequired]="false" class="fw-Advisor_SyncDetails" communityName="{{community}}"
        [articleId]="articleId"></content-management>
    </ng-container>
</div>

<ng-template #largeRef>
    <div class="fw-Advisor_AboutUsContent large-container">
        <ng-template [ngTemplateOutlet]="AboutUsContent">
        </ng-template>
    </div>
    <div *ngIf="forms" class="fw-Advisor_AboutUsContent large-container">
        <ng-template [ngTemplateOutlet]="Forms">
        </ng-template>
    </div>
    <div class="fw-Advisor_AboutUsContent large-container">
        <ng-template [ngTemplateOutlet]="ExternalLinks">
        </ng-template>
    </div>
</ng-template>
<ng-template #smallRef>
    <div class="fw-Advisor_AboutUsContent small-container">
        <ng-template [ngTemplateOutlet]="AboutUsContent">
        </ng-template>
    </div>
    <div *ngIf="forms" class="fw-Advisor_AboutUsContent small-container">
        <ng-template [ngTemplateOutlet]="Forms">
        </ng-template>
    </div>

    <div class="fw-Advisor_AboutUsContent small-container">
        <ng-template [ngTemplateOutlet]="ExternalLinks">
        </ng-template>
    </div>
</ng-template>

<ng-template #AboutUsContent>
    <div *ngIf="(entitledForAboutUs && hasAboutUs) || (entitledForContactUs && hasContactUs)" class="fw-Advisor_Primary">
        <content-management (hasContent)="hasAboutContent($event)" *ngIf="entitledForAboutUs && hasAboutUs" class="fw-Advisor_AboutUs" communityName="{{community}}"
            articleId="about_us"></content-management>
        <ng-container *ngIf="entitledForContactUs && hasContactUs && !isFromSiteBuilder">
            <hr *ngIf="entitledForAboutUs && hasAboutUs">
            <content-management *ngIf="!isA3KUser" (hasContent)="hasContactContent($event)" [isHeaderRequired]="true" class="fw-Advisor_ContactUs" communityName="{{community}}"
                articleId="custom_contactus"></content-management>

            <content-management *ngIf="isA3KUser" (hasContent)="hasContactContent($event)" [isHeaderRequired]="true" class="fw-Advisor_ContactUs" communityName="{{community}}"
              articleId="a3k_custom_contactus"></content-management>

        </ng-container>
        <ng-container *ngIf="entitledForContactUs && hasContactUs && isFromSiteBuilder">
            <hr *ngIf="entitledForAboutUs && hasAboutUs">
            <content-management (hasContent)="hasContactContent($event)" [isHeaderRequired]="true" class="fw-Advisor_ContactUs" communityName="{{community}}"
                articleId="contact_us"></content-management>
        </ng-container>
    </div>
    <div class="fw-Advisor_Secondary" *ngIf="entitledForAdvisorInfo">
        <advisor-info></advisor-info>
    </div>
</ng-template>
<ng-template #Forms>
    <div  class="fw-Advisor_Primary cm-Content">
        <ng-container >
            <hr >
            <content-management (hasContent)="hasContactContent($event)" [isHeaderRequired]="true" class="fw-Advisor_ContactUs" communityName="{{community}}"
                articleId="forms"></content-management>
        </ng-container>
    </div>
</ng-template>

<ng-template #ExternalLinks>
    <div  class="fw-Advisor_Primary">
        <ng-container >
            <hr >
            <content-management [isHeaderRequired]="true" class="fw-Advisor_ContactUs"
                articleId="external_links">
            </content-management>
            <content-management *ngIf="pathToInvesting" [isHeaderRequired]="true" class="" articleId="path_to_investing"></content-management>
        </ng-container>
    </div>
</ng-template>
